export const THEMES = Object.freeze({
    LIGHT: "light",
    DARK: "dark",
} as const);
